import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {Button} from "antd";
import {DiscountCodeFormValuesV2} from "../types";
import {CodeNameFormFieldV2} from "../code-name-form-field-v2";
import {DiscountCodeOfferingsFormFieldV2} from "../offerings-form-field-v2";
import {DiscountCodeCustomersFormFieldV2} from "../customers-form-field-v2";
import {DiscountCodeUsageFormFieldV2} from "../usage-form-field-v2";
import {DiscountCodeValidityFormFieldV2} from "../validity-form-field-v2";
import {getDiscountCodeFormSchema} from "../form-validation-schema";
import {useCreateDiscountCodeV2} from "../hooks";
import {CreateDiscountCodeSuccessModal} from "../success-modal";
import {
  StyledDiscountFormButtonWrapper,
  StyledDiscountFormWrapper,
} from "../styles/discount-form.styles";

export function CreateDiscountCodeFormPageV2() {
  const {
    createDiscountCode,
    handleModalOk,
    isCreatingDiscountCode,
    isSuccessModalOpen,
    responseData,
  } = useCreateDiscountCodeV2();

  const formMethods = useForm<DiscountCodeFormValuesV2>({
    resolver: yupResolver(getDiscountCodeFormSchema()),
    mode: "onSubmit",
    defaultValues: {
      customersType: "limited",
      offerings: [],
      usage: "one time",
      validity: [],
      selectAllOfferings: false,
    },
  });

  return (
    <StyledDiscountFormWrapper>
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(createDiscountCode)} autoComplete="off">
          <CodeNameFormFieldV2 />
          <DiscountCodeOfferingsFormFieldV2 />
          <DiscountCodeCustomersFormFieldV2 />
          <DiscountCodeUsageFormFieldV2 />
          <DiscountCodeValidityFormFieldV2 />

          <StyledDiscountFormButtonWrapper>
            <Button
              className="btn-primary"
              // size="large"
              type="primary"
              htmlType="submit"
              loading={isCreatingDiscountCode}
              disabled={
                Object.keys(formMethods.formState.errors).length > 0 ||
                Object.values(formMethods.watch()).length < 1
              }
            >
              Create discount
            </Button>
            <Button
              className="btn-secondary"
              onClick={() => formMethods.reset()}
              // size="large"
              type="default"
            >
              Cancel
            </Button>
          </StyledDiscountFormButtonWrapper>
        </form>
      </FormProvider>
      <CreateDiscountCodeSuccessModal
        handleOk={handleModalOk}
        openSuccessfulModal={isSuccessModalOpen}
        discountCode={responseData?.code}
      />
    </StyledDiscountFormWrapper>
  );
}
